<a class="notification-link" (click)="downloadFile()">{{
  'Dashboard::ClickHereToDownloadAgentCategoryReport' | abpLocalization
}}</a>
